import {Entity} from '../../../../../core/commons/entity';

export class DynOptionStringItem implements Entity {

    public id: number;
    private name: string;

    constructor(value: Object) {
        Object.assign(this, value);
    }

    getId(): number {
        return this.id;
    }

    setId(value: number) {
        this.id = value;
    }

    getName(): string {
        return this.name;
    }

    setName(value: string) {
        this.name = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/select/dyn-option-string-item.ts